<template>
  <svg
    width="140"
    height="140"
    viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="1" clip-path="url(#clip0)">
      <path
        id="line"
        d="M70 91.875V48.125"
        stroke="white"
        :style="line"
        stroke-width="10"
        stroke-miterlimit="10"
        stroke-linecap="round"
      />
      <circle id="dot" cx="70" cy="111.999" r="8" :style="dot" fill="white" />
      <path
        id="border"
        d="M79.0809 10.2663C78.2127 8.49885 76.8666 7.01012 75.1952 5.96899C73.5239 4.92785 71.5942 4.37598 69.6251 4.37598C67.6559 4.37598 65.7262 4.92785 64.0549 5.96899C62.3835 7.01012 61.0374 8.49885 60.1692 10.2663L4.91006 122.838C4.24488 124.191 3.93552 125.691 4.01118 127.197C4.08684 128.703 4.54502 130.165 5.34247 131.445C6.13992 132.724 7.25033 133.78 8.56887 134.511C9.88742 135.242 11.3706 135.626 12.8784 135.625H126.372C127.88 135.626 129.363 135.242 130.681 134.511C132 133.78 133.11 132.724 133.908 131.445C134.705 130.165 135.163 128.703 135.239 127.197C135.315 125.691 135.005 124.191 134.34 122.838L79.0809 10.2663Z"
        stroke="white"
        :style="border"
        stroke-width="10"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="140" height="140" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<script lang="ts">
import { Vue } from "vue-facing-decorator";
import { Component } from "vue-facing-decorator";

@Component({})
export default class AlertIcon extends Vue {
  public strokeLine = 0;
  public strokeDot = 0;
  public strokeBorder = 0;
  mounted() {
    this.strokeLine = (document.getElementById("line") as any).getTotalLength();
    this.strokeBorder = (
      document.getElementById("border") as any
    ).getTotalLength();
  }

  get line() {
    return {
      "stroke-dasharray": this.strokeLine,
      "stroke-dashoffset": this.strokeLine,
    };
  }

  get dot() {
    return {
      "stroke-dasharray": this.strokeDot,
      "stroke-dashoffset": this.strokeDot,
    };
  }
  get border() {
    return {
      "stroke-dasharray": this.strokeBorder,
      "stroke-dashoffset": this.strokeBorder,
    };
  }
}
</script>
<style scoped>
#line {
  animation: line-animation 2s ease forwards 0.3s;
}

#dot {
  animation: dot-animation 2s ease forwards 0.3s;
}

#border {
  animation: border-animation 2s ease forwards 0.3s;
}

@keyframes line-animation {
  to {
    stroke-dashoffset: 87.5;
  }
}

@keyframes dot-animation {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes border-animation {
  to {
    stroke-dashoffset: 847.5392456054688;
  }
}
</style>
